// @ts-ignore

import { GlobalFooter } from "@/patterns/global-footer/src/index";
import GlobalNavigation from "@/patterns/global-nav/src/index";

import { MainSection } from "./sections/main";

export const FourOhFourPageTemplate = () => {
    return (
        <div data-testid="404-page">
            <div>
                <GlobalNavigation
                    isShowTryNowLink={true}
                    tryNowLinkCtaButtonColor="light_grey"
                    productKey="404"
                />
            </div>
            <div>
                <div>
                    <MainSection />
                </div>
            </div>
            <GlobalFooter />
        </div>
    );
};
